/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect, useRef } from 'react'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest, checkValidation } from '../../../api/api'; // eslint-disable-next-line
import config from '../../../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify';
// eslint-disable-next-line
import FormGroupInput from '../../../common/FormGroupInput';
// eslint-disable-next-line
import { Row, Col, Button, Form } from 'react-bootstrap';
// eslint-disable-next-line
import CopiriLoader from '../../../common/CopiriLoader';
import image_loader from '../../../../assets/img/loader/small_loader.gif'; // eslint-disable-next-line
const PhoneField = props => {
	const { lodgeData, id, closeModal, updateLodgeModal, pageLanguageContent } = props;
	const [checkDataChange, setCheckDataChange] = useState(false);
	const [showLoader, setShowLoader] = useState(false);
	const [loader, setLoader] = useState(true);
	const [dialCodes, setDialCodes] = useState([]);
	const [inputField, setInputField] = useState({
		phone: '',
		dial: ''
	});
	const [validation, setValidation] = useState({
		error_phone: ''
	});

	useEffect(() => {
		if (props.id) {
			const { phone } = lodgeData;
			getPhoneDailCode();
			setInputField({ ...inputField, phone });
		}
		// eslint-disable-next-line
	}, [props.id]);

	/* function to get the input values */
	const inputsHandler = e => {
		setCheckDataChange(true);
		setInputField({ ...inputField, [e.target.name]: e.target.value });
	};

	/* function to get the dial codes */
	function getPhoneDailCode() {
		setLoader(true);
		copiriPortalRequest('/canon/dialcodes', config.app_version, 'get')
			.then(response => {
				setLoader(false);
				if (response.data.length > 0) {
					setDialCodes(response.data);
				}
			})
			.catch(error => {
				setLoader(false);
			});
	}

	/* function to update the phone filed on lodge modal */
	function updateData() {
		if (checkDataChange) {
			let errors = { ...validation };
			var errorCount = 0;
			var checkError = checkValidation(inputField['phone'], 'phone');
			if (!inputField.phone.trim()) {
				errors.error_phone = pageLanguageContent['CLD071'];
				errorCount++;
			} else if (!checkError) {
				errors.error_phone = pageLanguageContent['CLD072'];
				errorCount++;
			} else {
				errors.error_phone = '';
			}
			setValidation(errors);
			if (errorCount <= 0) {
				var sendFormData = {};
				var sendData = {};
				sendFormData['type'] = '';
				sendFormData['code'] = inputField['dial'];
				sendFormData['number'] = inputField['phone'];
				sendData['value'] = sendFormData;

				let d_code = '';
				for (let i = 0; i < dialCodes.length; i++) {
					if (dialCodes[i]['id'] === parseInt(inputField['dial'])) {
						d_code = dialCodes[i]['dialcode'];
					}
				}

				setShowLoader(true);
				copiriPortalRequest('/organizations/' + id + '/phone', config.app_version, 'patch', sendData)
					.then(response => {
						setShowLoader(false);
						if (response.data.status && response.data.status === 'SUCCESS') {
							toast.success(pageLanguageContent['CLD119']);
							closeModal();
							updateLodgeModal('phone', inputField['phone']);
							document.getElementById('user_phone_no').innerHTML = ' + ' + d_code + ' ' + inputField['phone'];
						}
					})
					.catch(error => {
						toast.error(error.response.data.result);
						setShowLoader(false);
					});
			}
		}
	}

	return (
		<>
			{loader ? (
				<CopiriLoader />
			) : (
				<Row className='mt-2'>
					<Col lg={4}>
						<Form.Group className='form-group'>
							<Form.Label for='dial'>{pageLanguageContent['CLD127'] ? pageLanguageContent['CLD127'] : ''}</Form.Label>
							<select
								id='dial'
								label='dial'
								type='text'
								onChange={inputsHandler}
								value={inputField.dial}
								name='dial'
								className='form-control'
							>
								{dialCodes.length > 0 &&
									dialCodes.map((item, i) => (
										<option value={item?.id} key={item.id}>
											(+ {item?.dialcode}) {item?.name}
										</option>
									))}
							</select>
						</Form.Group>
					</Col>
					<Col lg={8}>
						<FormGroupInput
							id='phone'
							label={pageLanguageContent['CLD013'] ? pageLanguageContent['CLD013'] : ''}
							placeholder={pageLanguageContent['CLD177'] ? pageLanguageContent['CLD177'] : ''}
							type='text'
							name='phone'
							onChange={inputsHandler}
							value={inputField.phone}
						/>
						{validation.error_phone && <p className='formValidationError'>{validation.error_phone}</p>}
					</Col>
					<Col lg={12}>
						<Button
							variant='primary'
							id={'confirmValidatebutton'}
							style={{ float: 'right', marginBottom: '15px' }}
							onClick={updateData}
						>
							{showLoader ? (
								<img src={image_loader} alt='loader' height='20' width='20' />
							) : pageLanguageContent['CLD124'] ? (
								pageLanguageContent['CLD124']
							) : (
								''
							)}
						</Button>
					</Col>
				</Row>
			)}
		</>
	);
};
export default PhoneField;
